const videoContainers = document.querySelectorAll('[data-video-container]');

videoContainers.forEach(videoContainer => {
  const videoElement = videoContainer.querySelector('video');
  const playPauseButton = videoContainer.querySelector('.video-control-wrapper');
  const progressBar = videoContainer.querySelector('.video-progress');

  if (!videoElement) return;

  // progress
  videoElement.addEventListener('timeupdate', (e) => {
    let progress = (100 / videoElement.duration) * videoElement.currentTime;
    videoContainer.querySelector('.video-progress__current').setAttribute("style",`width:${progress}%`);
  });

  progressBar.addEventListener('click', (e) => {
    let goToTime = (e.offsetX / progressBar.offsetWidth) * videoElement.duration;
    videoElement.currentTime = goToTime;
  });

  // play and pause
  playPauseButton.addEventListener('click', () => {
    playPauseButton.classList.toggle('playing');
    if (playPauseButton.classList.contains('playing')) {
      videoElement.play();
      setTimeout(() => {
        playPauseButton.classList.add('hide-control')
        progressBar.classList.add('hide-control')
        playPauseButton.blur()
        document.activeElement?.blur();
      }, 300)
    }
    else {
      playPauseButton.classList.remove('hide-control')
      progressBar.classList.remove('hide-control')
      videoElement.pause();
    }
  });

  videoElement.addEventListener('ended', () => {
    playPauseButton.classList.remove('playing');
    playPauseButton.classList.remove('hide-control')
  });

  // to show control when video is playing on mobile
  videoContainer.addEventListener('click', (e) => {
    if (playPauseButton.classList.contains('playing') && e.target.tagName === 'VIDEO') {
      playPauseButton.classList.remove('hide-control')
      progressBar.classList.remove('hide-control')
      setTimeout(() => {
        if(!videoElement.paused) {
          playPauseButton.classList.add('hide-control')
          progressBar.classList.add('hide-control')
        }
      }, 1500);
    }
  })
})



